import React from 'react';

import s from './Author.module.scss';
import {useIntl} from 'gatsby-plugin-intl';
import {GatsbyImage, getImage} from 'gatsby-plugin-image';


interface IAuthor {
  name: string;
  picture: any;
}

const Author = ({name, picture}: IAuthor) => {

  const intl = useIntl();

  return (
    <span className={s.author}>
      <span className={s.author__label}>{intl.formatMessage({id: 'post__author'})}</span>
      <GatsbyImage
        image={getImage(picture.localFile)!}
        alt={intl.formatMessage({id: 'product__certificat'})}
        className={s.author__image}
      />
      
      <span className={s.author__name}>{name}</span>
    </span>
  )
}

export default Author;
